import { AccountPlanType } from 'enums';
import { PlanProps } from 'types';

export const planConfig: Record<AccountPlanType, PlanProps> = {
  [AccountPlanType.Basic]: {
    name: 'Free',
    color: 'primary',
    icon: 'redeem',
    level: 1,
  },
  [AccountPlanType.Pro]: {
    name: 'Pro',
    color: 'success',
    icon: 'stars',
    level: 2,
  },
  [AccountPlanType.Premium]: {
    name: 'Premium',
    color: 'secondary',
    icon: 'award_star',
    level: 3,
  },
  [AccountPlanType.Unlimited]: {
    name: 'Broadcast Lite',
    color: 'secondary',
    icon: 'award_star',
    level: 4,
  },
  [AccountPlanType.BroadcastLite]: {
    name: 'Broadcast Lite',
    color: 'secondary',
    icon: 'award_star',
    level: 4,
  },
  [AccountPlanType.BroadcastStart]: {
    name: 'Broadcast Start',
    color: 'secondary',
    icon: 'award_star',
    level: 5,
  },
  [AccountPlanType.BroadcastRise]: {
    name: 'Broadcast Rise',
    color: 'secondary',
    icon: 'award_star',
    level: 6,
  },
  [AccountPlanType.BroadcastPrime]: {
    name: 'Broadcast Prime',
    color: 'secondary',
    icon: 'award_star',
    level: 7,
  },
};
